/**
 * Popisky VŠETKÝCH typov dokumentov, ktoré documents list môže vrátiť.
 *
 * Kľúče sú zámerne string literály, nie `IDocumentTypeId` z `/document` docu — ten enum je
 * len 5-hodnotový FILTER (main, info, order, kyc, fee-summary-statement, ostatné BE odmieta
 * 400). Response `DocumentListItem.typeId` je `string`, pretože bez filtra query vracia aj
 * `main-company`, `developer`, `marketplace-*` (viď komentár v `document-list-item.dto.ts`
 * v investin-api).
 */
const documentTypeLabel = {
  main: 'Rámcová zmluva',
  'main-company': 'Rámcová zmluva - Firma',
  developer: 'Rámcová zmluva',
  order: 'Objednávka investície',
  kyc: 'KYC',
  info: 'Informačné povinnosti',
  'marketplace-seller': 'Príkaz na postúpenie investície',
  'marketplace-buyer': 'Príkaz na postúpenie investície',
  'marketplace-agreement': 'Zmluva o postúpení investície',
  'marketplace-invoice': 'Faktúra predaj investície',
  'fee-summary-statement': 'Výpis poplatkov',
} as const

export function getDocumentTypeLabel(typeId: string): string | undefined {
  return documentTypeLabel[typeId as keyof typeof documentTypeLabel]
}
